export default __webpack_public_path__ + "static/gba_ep5_compressed-6bdfad0283066eabc7357501d963e353.mp4";